import {
  faSpinner,
  faTimes,
  faWarning,
} from "@fortawesome/pro-regular-svg-icons";
import { twJoin } from "tailwind-merge";

import { Pill } from "src/base-components/Pill";
import { Icon, IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type InvalidFlowDisplayProps = {
  flowSlug: string;
  loading?: boolean;
  dataLoc?: string;
  onClear?: () => void;
};

export const InvalidFlowDisplay: React.FC<InvalidFlowDisplayProps> = ({
  flowSlug,
  loading,
  dataLoc,
  onClear,
}) => (
  <div
    className={twJoin(
      "flex h-8 w-full items-center justify-between rounded-lg border bg-white px-3 py-1.5 font-inter-normal-12px text-gray-800",
      loading ? "border-gray-200" : "border-red-600 ring-2 ring-red-400/25",
    )}
    data-loc={dataLoc}
  >
    <span className={twJoin("truncate", loading && "text-gray-500")}>
      {flowSlug}
    </span>
    <div className="ml-auto flex items-center">
      {loading ? (
        <Icon icon={faSpinner} size="xs" spin />
      ) : (
        <>
          <Tooltip
            title={
              <span>
                Decision Flow{" "}
                <Pill size="sm" variant="dark-gray">
                  <Pill.Text fontType="code-12">{flowSlug}</Pill.Text>
                </Pill>{" "}
                does not exist in current workspace
              </span>
            }
            asChild
          >
            <span data-loc={dataLoc && `${dataLoc}-error-tooltip-icon`}>
              <Icon icon={faWarning} size="xs" variant="error" />
            </span>
          </Tooltip>
          {onClear && (
            <div className="flex items-center">
              <div className="mx-1.5 h-4 w-[1px] bg-gray-200" />
              <IconButton
                aria-label="Clear flow selection"
                dataLoc={dataLoc ? `${dataLoc}-clear` : undefined}
                icon={faTimes}
                size="xs"
                onClick={onClear}
              />
            </div>
          )}
        </>
      )}
    </div>
  </div>
);
